import { NavigationView } from '@/shared/constants/navigation-view.enum';
import { createContext, type Dispatch, type SetStateAction } from 'react';
import { UsuarioConfigs } from '../types/usuario_config';

interface MyContextType {
  state: UsuarioConfigs;
  setState: Dispatch<SetStateAction<UsuarioConfigs>>;
  /** Permissões sincronizadas com `/auth/me` antes de checar rotas protegidas. */
  sessionReady: boolean;
  /** Visão efetiva retornada por `/auth/me` (null até a sessão carregar). */
  authVisao: NavigationView | null;
  ehDefensorDiretor: boolean;
  /** Lotação no setor Corregedoria (espelha `/relatorios/atividades/corregedoria/check`). */
  isCorregedoria: boolean;
  /** Assessor com `permite_editar_relatorio_defensor` vinculado a um defensor ativo. */
  assessorPodeEditarRelatorio: boolean;
  /** Usuário com ao menos um painel gerencial ativo liberado. */
  temPainelGerencial: boolean;
}

const MyContext = createContext<MyContextType | undefined>(undefined);

export default MyContext;
